import { Checkbox } from '@fluentui/react-components';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { IPermissionsDialogForm } from '../../../PermissionsDialogForm';
import { PermissionsHStack } from '../../PermissionsHStack';
import { PermissionsField } from '../PermissionsField';

export function PermissionsOtherGroup() {
  const { t } = useTranslation();
  const { control } = useFormContext<IPermissionsDialogForm>();
  return (
    <PermissionsField label={t('permissions.modifyAction.otherGroup.label')}>
      <PermissionsHStack>
        <Controller
          control={control}
          name="isFolderOwner"
          render={({ field: { value, onChange } }) => (
            <Checkbox
              label={t('permissions.modifyAction.otherGroup.options.folderOwner')}
              checked={value}
              onChange={(_, d) => {
                onChange(d.checked);
              }}
            />
          )}
        />
        <Controller
          control={control}
          name="isFolderContact"
          render={({ field: { value, onChange } }) => (
            <Checkbox
              label={t('permissions.modifyAction.otherGroup.options.folderContact')}
              checked={value}
              onChange={(_, d) => {
                onChange(d.checked);
              }}
            />
          )}
        />
        <Controller
          control={control}
          name="isFolderVisible"
          render={({ field: { value, onChange } }) => (
            <Checkbox
              label={t('permissions.modifyAction.otherGroup.options.folderVisible')}
              checked={value}
              onChange={(_, d) => {
                onChange(d.checked);
              }}
            />
          )}
        />
      </PermissionsHStack>
    </PermissionsField>
  );
}
